import { render } from "./trader-trading.vue?vue&type=template&id=ced6aa3e"
import script from "./trader-trading.vue?vue&type=script&lang=js"
export * from "./trader-trading.vue?vue&type=script&lang=js"

import "./trader-trading.vue?vue&type=style&index=0&id=ced6aa3e&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__